import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    shiftSchedules: [],
    total: null,
    page: 1,
    perPage: 5,
    dates: [],
    schedularFormData: {},
    loading: false,
    shiftTypes: [],
  },
  actions,
  mutations,
};
